const classes = {
  class: "Klasse",
  classes: "Klassen",
  publication: "Veröffentlichung",
  level: "Level",
  create: "Neue Klasse erstellen",
  follow: "Meine Klassen",
  followed: "Meine Klassen",
  edit: "Klasse bearbeiten",
  save: "Klasse speichern",
  hasNoClassWarning: "Sie haben derzeit noch keine Klassen.",
  hasNoClassWithStudentStart: "Sie haben",
  hasNoClassWithStudentEnd:
    "Klasse(n), auf die noch kein Schüler bei iizenglish zugegriffen hat. Die Klassen werden angezeigt, sobald sich mindestens ein Schüler angemeldet hat.",
  deleteStudentQuestion: "Diesen Schüler aus der Klasse entfernen?",
  deleteStudentDescription:
    "Der Schüler wird nicht mehr Teil dieser Klasse sein. Nach der Bestätigung wird die Aktion sofort ausgeführt.",
  selectedClasses: "Ausgewählte Klassen",
  atLeastOneSelectedClass: "Bitte wählen Sie mindestens eine Klasse aus.",
  searchSchoolHere: "Schule suchen…",
  searchTeacherHere: "Lehrer suchen…",
  searchSchoolHelp:
    "Bitte wählen Sie eine Schule aus der Dropdown-Liste aus oder lassen Sie das Feld leer, wenn Sie keiner Schule angehören.",
  removedTeacherClassHelp:
    "Speichern Sie die Klasse, damit die Änderungen wirksam werden.",
  searchClassHere: "Klasse suchen…",
  languageHelp:
    "Wird verwendet, um die Sprache der an den Schüler gesendeten E-Mails festzulegen.",
  addTeacherModalTitle: "Klasse beitreten",
  addTeacherModalContent:
    "Sie sind dabei, der Klasse {className} als Lehrkraft beizutreten. Sind Sie sicher?",
  newTeacher: "Neue Lehrkraft",
  theWholeClass: "Ganze Klasse",
  theWholeClasses: "Alle Klassen",
  myClasses: "Meine Klassen",
  atLeastOneLevel: "Bitte wählen Sie mindestens ein Niveau aus.",
  deleteClassQuestionForTeacher:
    "Sind Sie sicher, dass Sie diese Klasse löschen möchten?",
  deleteClassWarning:
    "Diese Aktion kann nicht rückgängig gemacht werden. Aufgaben, die nur dieser Klasse zugewiesen sind, werden ebenfalls gelöscht.",
  className: "Klassenname",
  classCreation: "Klasse erstellen",
  classEdition: "Klasse bearbeiten",
  notEditable:
    "Diese Klasse wurde aus Ihrem LMS importiert und kann nicht bearbeitet werden.",
  addClass: "Klasse hinzufügen",
  classList: "Klassenliste",
  deleteClassQuestion: "Diese Klasse löschen?",
  deleteClass: "Klasse löschen",
  deleteClassDescription:
    "Alle zugehörigen Aufgaben und Noten werden dauerhaft gelöscht.",
};

export default classes;
